import React from "react";
import Confetti from "react-confetti";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <div className="about-text">
        <h2>About Us</h2>
        <p>
        Built  by <strong>Ankit</strong> & <strong>Yash</strong>, this geo-tool takes the pain out of geospatial math and turns it into a breeze! 🎈<br/>

        From Haversine to Great Circle Routing, we simplify the jargon so you don’t have to scratch your head. <br/><br/>
        Made with ❤️, designed for you!
        </p>
      </div>
      <div className="confetti-animation">
        <Confetti numberOfPieces={100} />
      </div>
    </div>
  );
};

export default AboutUs;